/* contains utility methods for CC payments. uses https://github.com/jondavidjohn/payform to perform credit card validations */
import modal from './modal';
import { getStyleguideClasses, getUiLibraryClasses } from '../utils';
let CCUTILS = {};
let payform = require('payform');

//new maestro cards with bins 5811 are not supported by default configuration ,
payform.cards.push({
  type: 'maestro',
  pattern: /^(5(018|0[23]|[68])|6(39|7))/,
  length: [12, 13, 14, 15, 16, 17, 18, 19],
  cvcLength: [3],
  luhn: true,
  format: /(\d{1,4})/g,
});

CCUTILS.payform = payform;

CCUTILS.getPayForm = function () {
  return CCUTILS.payform;
};

CCUTILS.showGeneralError = function () {
  const errorMessage = $('.accordion__panel.active').find(
    '.js-adyenFormValidation .info__text'
  );
  const generalFormError = $('#generalFormError').text();

  if (errorMessage.is(':empty')) {
    const errorDiv = $('<div class="z-alert__text"></div>').text(
      generalFormError
    );
    errorDiv.appendTo(errorMessage);
  }
};

CCUTILS.setInvalid = function (invalidInput) {
  invalidInput.closest('.form__field').removeClass('ERROR');
  const spanElem =
    '<svg class="checkout__icon error__icon" aria-hidden="true"><use xlink:href="#error-circle"></use></svg>';
  const emptyFieldText = $('#emptyFieldText').text();
  const invalidText = $('#invalidText').text();
  let inputText = invalidInput.val();
  let inputLabel = $('label[for="' + invalidInput.attr('id') + '"]:visible')
    .contents()
    .get(0).nodeValue;

  invalidInput.closest('.form__field').addClass('ERROR');
  const errorIcon = invalidInput.next('.error__icon');

  if (errorIcon.length === 0) {
    invalidInput.after(spanElem);
  }

  if (inputText != null) {
    inputText = inputText.trim();
    if (inputText.length === 0) {
      this.showGeneralError();
      invalidInput
        .siblings('div.error__message')
        .find('span')
        .text(emptyFieldText.replace('{0}', inputLabel));
    } else {
      this.showGeneralError();
      if (invalidInput.siblings('span.error__message').length > 0) {
        invalidInput
          .siblings('span.error__message')
          .text(invalidText.replace('{0}', inputLabel));
      } else {
        invalidInput
          .siblings('div.error__message')
          .find('span')
          .text(invalidText.replace('{0}', inputLabel));
      }
    }
  }
};

//  Check if current inserted credit card is supported by this country.
CCUTILS.isCCSupported = function () {
  const type = document.getElementById('ccnum-type');
  return (
    type.innerHTML !== 'invalid' &&
    $('.img__panel img[data-ccname^=' + type.innerHTML + ']').length > 0
  );
};

CCUTILS.validateCCardNumber = function (cardNumber) {
  const isValid = CCUTILS.getPayForm().validateCardNumber(cardNumber.value);
  const cardNumberElem = $(cardNumber);
  if (!isValid) this.setInvalid(cardNumberElem, isValid);
  else cardNumberElem.parent('form__field').removeClass('ERROR');
  return isValid;
};

CCUTILS.validateCardOwner = function ($holderNameInput) {
  const holderName = $holderNameInput.val().trim();
  const hasDigits = holderName.match(/\d+/g);
  const isValid =
    holderName.length > 0 && hasDigits === null && holderName.length <= 30;
  if (isValid) $holderNameInput.closest('.form__field').removeClass('ERROR');
  else this.setInvalid($holderNameInput, isValid);
  return isValid;
};

CCUTILS.validateExpiryDate = function (monthInput, yearInput) {
  const inputLabel = $('label[for="' + monthInput.attr('id') + '"]')
    .contents()
    .get(0).nodeValue;
  const emptyFieldText = $('#emptyFieldText').text();
  const invalidExpiryDateText = $('#invalidExpiryDateText').text();
  const month = monthInput.val();
  const year = yearInput.val();
  const expiry = new Date(year, month);
  const currentTime = new Date();
  let isValid;
  let errorMessage;

  expiry.setMonth(expiry.getMonth() - 1);
  expiry.setMonth(expiry.getMonth() + 1, 1);

  const isFutureDate = expiry > currentTime;
  isValid = month !== '0' && year !== '0' && isFutureDate;
  if (month === '0' || year === '0') errorMessage = emptyFieldText;
  else if (!isFutureDate) errorMessage = invalidExpiryDateText;

  if (isValid) {
    monthInput.closest('.form__field').removeClass('ERROR');
    yearInput.closest('.form__field').removeClass('ERROR');
  } else {
    monthInput.closest('.form__field').addClass('ERROR');
    yearInput.closest('.form__field').addClass('ERROR');
    yearInput
      .parent()
      .next('div.error__message')
      .find('span')
      .text(errorMessage.replace('{0}', inputLabel));
    this.showGeneralError();
  }
  return isValid;
};

CCUTILS.validateCardCVC = function (cvc, cctype) {
  const cvcElem = $(cvc);
  let isValid = CCUTILS.getPayForm().validateCardCVC(cvc.value, cctype);
  if (cctype === 'amex' && cvcElem.val().length !== 4) {
    isValid = false;
  }
  if (cctype !== 'amex' && cvcElem.val().length !== 3) {
    isValid = false;
  }

  if (!isValid) this.setInvalid(cvcElem, isValid);
  else cvcElem.closest('.form__field').removeClass('ERROR');

  return isValid;
};

function handleAmexCards(cardType) {
  const cvcLabel = $('label[data-zta="cvc-label-normal"]');
  const cvcAmexLabel = $('label[data-zta="cvc-label-amex"]');
  const cvcImg = $('img[data-zta="cvc-img-normal"]');
  const cvcImgAmex = $('img[data-zta="cvc-img-amex"]');
  const cvcText = $('div[data-zta="cvc-text-normal"]');
  const cvcTextAmex = $('div[data-zta="cvc-text-amex"]');
  const cvcInput = $('#card\\.cvcCode');
  const cvcInputUpdate = $('#updateAdyenCvc');
  if (cardType === 'amex') {
    cvcLabel.hide();
    cvcImg.hide();
    cvcText.hide();

    cvcAmexLabel.show();
    cvcImgAmex.show();
    cvcTextAmex.show();

    cvcInput.attr('maxlength', 4);
    cvcInputUpdate.attr('maxlength', 4);

    cvcInput.attr(
      'aria-describedby',
      'cvcNewAmexMessage adyenNewCardCodeError'
    );
    cvcInputUpdate.attr(
      'aria-describedby',
      'cvcUpdateMessage adyenUpdateCardCodeError'
    );
  } else {
    cvcLabel.show();
    cvcImg.show();
    cvcText.show();

    cvcAmexLabel.hide();
    cvcImgAmex.hide();
    cvcTextAmex.hide();

    cvcInput.attr('maxlength', 3);
    cvcInputUpdate.attr('maxlength', 3);

    cvcInput.attr('aria-describedby', 'cvcNewMessage adyenNewCardCodeError');
    cvcInputUpdate.attr(
      'aria-describedby',
      'cvcUpdateMessage adyenUpdateCardCodeError'
    );
  }
}

//  Logic to handle the change of the credit card images.
CCUTILS.updateType = function () {
  const payform = CCUTILS.getPayForm();
  const type = document.getElementById('ccnum-type');
  const ccnum = document.getElementById('card.cardNumber');
  const images = $('.img__panel img:not(#activeImage)');
  let cardType = payform.parseCardType($(ccnum).val());

  if (cardType === 'mastercard') {
    cardType = 'mc';
  }
  if (cardType === 'dinersclub') {
    cardType = 'diners';
  }
  if (cardType === 'visaelectron' || cardType === 'bancontact') {
    cardType = 'visa';
  }
  // Change CVC info for amex cards
  handleAmexCards(cardType);

  if (cardType !== null) {
    let cardTypeSupported =
      $('.img__panel img[data-ccname^=' + cardType + ']').length > 0;

    if (cardTypeSupported) {
      //  Card type is supported
      $(ccnum).closest('.form__field').removeClass('ERROR');
      $('#activeImage').removeClass('has__error');
      CCUTILS.setActiveCard(cardType);
    } else {
      $(ccnum).closest('.form__field').addClass('ERROR');
      images.addClass('grey__card');
      CCUTILS.removeActiveCard();
    }
  } else {
    if ($(ccnum).val().length > 1) {
      CCUTILS.setInvalid($(document.getElementById('card.cardNumber')));
      $(ccnum).closest('.form__field').addClass('ERROR');
      images.addClass('grey__card');
      CCUTILS.removeActiveCard();
    } else {
      images.removeClass('grey__card');
      CCUTILS.removeActiveCard();
    }
  }

  type.innerHTML = cardType || 'invalid';
};

CCUTILS.cleanCardNumberOnChange = function () {
  let parent = $(this).closest('.form__field');
  if (parent.hasClass('ERROR')) {
    parent.removeClass('ERROR');
  }
};

/* END helper functions for EE validation*/

/* BEGIN Function for removing credit card using AJAX*/

//  Event handler if the user clicks to the X button from the stored credit card list.
CCUTILS.removeCardClicked = function (e) {
  const removeCardModal = $('#modal-removeCard');
  e.stopPropagation();
  if (removeCardModal.length > 0) {
    //  Get the credit card row to remove and add it into the modal views Html.
    const cardToRemove = $(this).parents('.js-cardContainer').clone();
    cardToRemove.find('.card__icons').remove();
    cardToRemove.removeClass('card__selected');
    resetRemoveModalView(removeCardModal);
    $('#remove-card-text').css('display', 'block');
    $('#adyen-removeCC-form').append(cardToRemove);
    modal.openModal(removeCardModal);
  }
};

CCUTILS.removeBancontactCardClicked = function () {
  const removeCardModal = $('#modalRemoveBancontactCard');
  let form = $('#bancontactRemoveCardForm');
  if (removeCardModal.length > 0) {
    //  Get the credit card row to remove and add it into the modal views Html.
    form.find('.js-cardContainer').remove();
    const cardToRemove = $(this).parents('.js-cardContainer').clone();
    cardToRemove.find('.card__icons').remove();
    cardToRemove.removeClass('card__selected');
    removeCardModal.find('.info__box').css('display', 'none');
    removeCardModal.find('#bancontactRemoveCardForm').css('display', 'block');
    $('#bancontact-removeAllCardsText').css('display', 'none');
    $('#bancontactRemoveCardBtn').removeAttr('disabled');
    $('#bancontactRemoveCardText').css('display', 'block');
    form.append(cardToRemove);
    modal.openModal(removeCardModal);
  }
};

//  Event handler if the user clicks to the Delete all cards button from the stored credit card list.
CCUTILS.removeAllCardsClicked = function () {
  const removeCardModal = $('#modal-removeCard');

  if (removeCardModal.length > 0) {
    //  Get the credit card row to remove and add it into the modal views Html.
    resetRemoveModalView(removeCardModal);
    $('#removeAllCardsText').css('display', 'block');
    modal.openModal($('#modal-removeCard'));
  }
};

//  AJAX call for removing the credit card.
CCUTILS.removeCard = function (
  cardId,
  paymentMethod,
  successCallback,
  errorCallback
) {
  $.ajax({
    type: 'POST',
    url: '/checkout/editpayment',
    data: { removedCardRef: cardId, paymentMethod: paymentMethod },
    success: function (msg) {
      successCallback(cardId, msg);
    }, //  Success callback with card id to remove and data coming from the server.
    error: function () {
      errorCallback;
    },
  });
};

CCUTILS.bancontactCardRemoveSuccessCallback = function (cardId, isRemoved) {
  const modalView = $('#modalRemoveBancontactCard');
  if (isRemoved) window.location.reload();
  else cardRemoveErrorCallback($('#bancontactRemoveCardBtn'), modalView);
};

CCUTILS.cardRemoveSuccessCallback = function (cardId, isRemoved) {
  const modalView = $('#modal-removeCard');
  if (isRemoved) {
    if (!cardId || cardId.length === 0 || cardId === 'bancontact') {
      window.location.reload();
    } else {
      if ($('.js-cardWrapper').length === 1) {
        window.location.reload();
      } else {
        modal.disposeModal(modalView);
        $(`[data-cardReference="${cardId}"]`)
          .parent('.js-cardWrapper')
          .fadeOut(function () {
            $(this).remove();
          });
        CCUTILS.hideLoadingAnimationButton($('#js-submitRemoveCard'));
      }
      $('.js-adyen-remove-card-success').removeClass('hidden');
    }
  } else {
    cardRemoveErrorCallback($('#js-submitRemoveCard'), modalView);
  }
};

//  An error occured on the server. Card cannot be removed, show error msg.
function cardRemoveErrorCallback(removeCardBtn, modal) {
  modal.find('.info__box.ERROR').fadeIn(200);
  removeCardBtn.removeAttr('disabled');
  CCUTILS.hideLoadingAnimationButton(removeCardBtn);
}

/* END Function for removing credit card using AJAX*/

CCUTILS.checkUniqueCreditCardProvider = function () {
  const activeCC = $('.cc-image[style^="display: inline"]');
  //  Check if we have a unique credit card detection.
  return activeCC.length <= 1;
};

//  Reset the view of the delete card modal view on each call.
function resetRemoveModalView($modalView) {
  $modalView.find('.js-cardContainer').remove();
  $modalView.find('.info__box').css('display', 'none');
  $modalView.find('#adyen-removeCC-form').css('display', 'block');
  $('#remove-card-text').css('display', 'none');
  $('#removeAllCardsText').css('display', 'none');
  $('#remove-card').removeAttr('disabled');
}
/* END Function for removing credit card using AJAX*/

// There are more card variants than networks, and payform needs the network, not the variant
CCUTILS.getCardNetwork = function (cardVariant) {
  if ('bijcard' === cardVariant || 'mc' === cardVariant) {
    return 'mastercard';
  } else {
    return cardVariant;
  }
};
/* END Function for getting card network */

// Updating CC form
CCUTILS.populateUpdateCCForm = function (selectedCard, form, isExpired) {
  const number = selectedCard.attr('data-number');
  const prefix = $.trim(selectedCard.attr('data-numberprefix'));
  const holder = selectedCard.attr('data-holdername');
  const expiryYear = selectedCard.attr('data-expiryyear');
  const reference = selectedCard.attr('data-cardReference');
  const variant = selectedCard.attr('data-cardvariant');
  const network = this.getCardNetwork(variant);

  const monthElem = $('#updateAdyenExpiryMonth');
  const yearElem = $('#updateAdyenExpiryYear');
  const cvcElem = $('#updateAdyenCvc');
  let expiryMonth = selectedCard.attr('data-expirymonth');

  // Month is internally represented without leading zero
  if (expiryMonth.length === 1) {
    expiryMonth = '0' + expiryMonth;
  }
  form.attr('data-cardnetwork', network);
  form.find('#updateAdyenCardNumber').val(prefix + ' ' + number);
  form.find('#updateAdyenHolderName').val(holder);
  form.find('#updateAdyenExpiryMonth').val(expiryMonth);
  form.find('#updateAdyenExpiryYear').val(expiryYear);
  form.find('input[name="selectedRecurringDetailReference"]').val(reference);

  if (isExpired) {
    monthElem.removeAttr('disabled');
    yearElem.removeAttr('disabled');
    cvcElem.val('');
    cvcElem.closest('.form__field').removeClass('ERROR');
    form.find('#updateAdyenCardType').val('EXPIRED');
  } else {
    monthElem.attr('disabled', 'disabled');
    monthElem.closest('.form__field').removeClass('ERROR');
    yearElem.attr('disabled', 'disabled');
    yearElem.closest('.form__field').removeClass('ERROR');
    cvcElem.closest('.form__field').removeClass('ERROR');
    cvcElem.val('');
    form.find('#updateAdyenCardType').val('ONECLICK');
  }

  handleAmexCards(variant);

  form.find('.img__panel img').each(function () {
    const $currentImg = $(this);
    if ($currentImg.attr('data-ccname') === variant) {
      $currentImg.css('display', 'inline');
    } else {
      $currentImg.css('display', 'none');
    }
  });
};
/* END Function for populating update card modal */

// Handles update form post
CCUTILS.handleUpdateCCFormPost = function (form) {
  const $updateBtn = $('#updateCC-form').find('button[type=submit]');
  const updateCardError = $('.js-updateCardError');
  const $expiryMonth = $('#updateAdyenExpiryMonth');
  const $expiryYear = $('#updateAdyenExpiryYear');

  $('.accordion__panel.active')
    .find('.js-adyenFormValidation .info__text')
    .empty();
  updateCardError.hide();

  const network = form.attr('data-cardnetwork');
  const cvc = document.getElementById('updateAdyenCvc');
  let isFormValid = [];

  isFormValid.push(CCUTILS.validateCardCVC(cvc, network));

  if (!$expiryMonth.attr('disabled') && !$expiryYear.attr('disabled')) {
    isFormValid.push(CCUTILS.validateExpiryDate($expiryMonth, $expiryYear));
  }

  if (!isFormValid.every(Boolean)) {
    //  Show error panel
    updateCardError.fadeIn();
    CCUTILS.hideLoadingAnimationButton($updateBtn);
    return false; // Do not submit if form is not valid.
  }
  return true;
};

//  Card data included into the request.
CCUTILS.setCardDataInRequest = function (
  cardNumber,
  holderName,
  expiryMonth,
  expiryYear
) {
  // Set the hidden fields
  const number = cardNumber.value.replace(/\s/g, '');
  const type = document.getElementById('ccnum-type');
  $('#adyenNumber').val(number.substr(number.length - 4));
  $('#adyenHolderName').val(holderName.val().trim());
  $('#adyenExpiryMonth').val(expiryMonth.val());
  $('#adyenExpiryYear').val(expiryYear.val());

  if ($('input[type=hidden][name="adyenCardType"]').val() === '') {
    $('#adyenCardType').val(type.innerHTML);
  }
};
CCUTILS.setBancontactCardDataInRequest = function (
  cardNumber,
  holderName,
  expiryMonth,
  expiryYear
) {
  // Set the hidden fields
  const number = cardNumber.value.replace(/\s/g, '');
  $('#bancontactNumber').val(number.substr(number.length - 4));
  $('#bancontactHolderName').val(holderName.val().trim());
  $('#bancontactExpiryMonth').val(expiryMonth.val());
  $('#bancontactExpiryYear').val(expiryYear.val());
};

CCUTILS.hideLoadingAnimationButton = function (submitBtn) {
  const legacyPagesButtonIds = ['editPaymentSubmit'];
  const btnLoadingClassArr = legacyPagesButtonIds.includes(
    $(submitBtn).attr('id')
  )
    ? getUiLibraryClasses(['btn--loading'])
    : getStyleguideClasses(['btn--loading']);
  submitBtn.removeAttr('disabled');
  submitBtn.blur();
  submitBtn.removeClass(...btnLoadingClassArr);
};

CCUTILS.loginUpdateType = () => {
  const $activeCards = $('#img-panel img:not(.grey__card):not(#activeImage)');
  if ($activeCards.length === 1) {
    const imgPanelText = $('#img-panel span');
    imgPanelText.addClass('hidden');
    CCUTILS.setActiveCard($activeCards.attr('data-ccname'));
  } else {
    CCUTILS.removeActiveCard();
  }
};

CCUTILS.setActiveCard = (cardType) => {
  const images = $('#img-panel img:not(#activeImage)');
  const activeCard = document.getElementById('activeImage');
  if (activeCard.getAttribute('alt') !== cardType) {
    CCUTILS.removeActiveCard();
  }
  if (activeCard.classList.contains('hidden')) {
    setCard(activeCard, cardType);
    images.addClass('hidden');
  }
};

CCUTILS.removeActiveCard = () => {
  const images = $('#img-panel img:not(#activeImage)');
  const activeCard = document.getElementById('activeImage');
  if (!activeCard.classList.contains('hidden')) {
    removeCard(activeCard);
    images.removeClass('hidden');
  }
};

const setCard = (img, card) => {
  img.setAttribute('alt', card);
  img.setAttribute('data-ccname', card);
  img.setAttribute('src', `${img.src}/${card}_2x.png`);
  img.classList.remove('hidden');
};

const removeCard = (img) => {
  img.removeAttribute('alt');
  img.removeAttribute('data-ccname');
  img.setAttribute('src', img.src.split('/').slice(0, -1).join('/'));
  img.classList.add('hidden');
};

export default CCUTILS;
